(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["etsy-testimonials"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-etsy-testimonials]').forEach((carousel) => {
    if (carousel.dataset.carouselReady === 'true') return;

    const viewport = carousel.querySelector('[data-testimonial-viewport]');
    const slides = Array.from(carousel.querySelectorAll('[data-testimonial-slide]'));
    const previous = carousel.querySelector('[data-testimonial-previous]');
    const next = carousel.querySelector('[data-testimonial-next]');

    if (!viewport || slides.length === 0) return;

    carousel.dataset.carouselReady = 'true';

    const updateControls = () => {
      if (!previous || !next) return;
      const maximum = viewport.scrollWidth - viewport.clientWidth;
      previous.disabled = viewport.scrollLeft <= 4;
      next.disabled = viewport.scrollLeft >= maximum - 4;
    };

    const move = (direction) => {
      const step = slides[1] ? slides[1].offsetLeft - slides[0].offsetLeft : slides[0].offsetWidth;
      viewport.scrollBy({ left: step * direction, behavior: 'smooth' });
    };

    previous?.addEventListener('click', () => move(-1));
    next?.addEventListener('click', () => move(1));
    viewport.addEventListener('scroll', updateControls, { passive: true });
    viewport.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        move(-1);
      }

      if (event.key === 'ArrowRight') {
        event.preventDefault();
        move(1);
      }
    });

    new ResizeObserver(updateControls).observe(viewport);
    updateControls();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shelldance-welcome"]) return;
  try {
    
(() => {
 const init = () => {
  const dialog = document.getElementById('sd-welcome');
  if (!dialog || dialog.dataset.ready) return;
  dialog.dataset.ready = 'true';
  const reopen = document.getElementById('sd-welcome-reopen');
  const read = (store,key) => { try { return store.getItem(key); } catch { return null; } };
  const write = (store,key,value) => { try { store.setItem(key,value); } catch {} };
  const key = 'sd-welcome-dismissed';
  const pending = read(sessionStorage,'sd-welcome-pending');
  let previousFocus;
  let oldOverflow;
  const open = () => {
   if (dialog.open || document.querySelector('dialog[open]')) return;
   previousFocus = document.activeElement;
   oldOverflow = document.body.style.overflow;
   dialog.showModal();
   document.body.style.overflow = 'hidden';
  };
  dialog.querySelectorAll('[data-sd-close]').forEach(button => button.addEventListener('click', () => dialog.close()));
  dialog.addEventListener('click', event => { if (event.target === dialog) { const r=dialog.getBoundingClientRect(); if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom) dialog.close(); } });
  dialog.addEventListener('close', () => {
   document.body.style.overflow = oldOverflow || '';
   write(localStorage,key,String(Date.now()));
   reopen.hidden = false;
   if (previousFocus && previousFocus !== document.body) previousFocus.focus();
   else reopen.focus();
  });
  reopen.addEventListener('click',open);
  const form = document.getElementById('sd-welcome-form');
  form?.addEventListener('submit',() => write(sessionStorage,'sd-welcome-pending','1'));
  const success = dialog.querySelector('[data-sd-success]');
  if (pending === '1' && (success || dialog.querySelector('[data-sd-errors]'))) {
   if (success) { write(localStorage,'sd-welcome-joined','1'); write(sessionStorage,'sd-welcome-pending','0'); }
   open();
   return;
  }
  const dismissed = Number(read(localStorage,key) || 0);
  const joined = read(localStorage,'sd-welcome-joined') === '1' || dialog.dataset.subscriber === 'true';
  reopen.hidden = joined;
  if (!joined && Date.now()-dismissed > 14*86400000) setTimeout(open,Number(dialog.dataset.delay)*1000);
 };
 if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',init); else init();
 document.addEventListener('shopify:section:load',init);
})();

  } catch(e) { console.error(e); }
})();
})();
